import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faMinusSquare } from '@fortawesome/free-solid-svg-icons';
import { RootState, useDispatch, useSelector } from '../../redux/store';
import { createInventoryJob, updateInventoryJob, deleteInventoryJob } from '../../redux/slices/inventoryJob';
import type { ICellRendererParams } from 'ag-grid-community';
import type { InventoryJob } from '../../types/inventoryJob';

const ActionsInventoryJobRenderer = (props: ICellRendererParams) => {
  const dispatch = useDispatch();
  const { inventoryJobRowData } = useSelector((state: RootState) => state.inventoryJob);
  const [isEditable, setIsEditable] = useState<boolean>(false);
  const [isDeletable, setIsDeletable] = useState<boolean>(false);

  const data: InventoryJob = props.data;
  const jobStatus: string = data.jobStatus;

  /**
   * 確認用
   */
  // useEffect(() => {
  //   console.log(inventoryJobRowData);
  // }, [inventoryJobRowData]);

  useEffect(() => {
    if (jobStatus === '0') {
      setIsEditable(true);
      setIsDeletable(true);
    }
    if (jobStatus === '1') {
      setIsEditable(true);
    }
  }, []);

  /**
   * Editボタンを押した時
   */
  const handleEditRow = (): void => {
    // console.log(props)
    if (isEditable) {
      const editData: InventoryJob = inventoryJobRowData.find((job: InventoryJob) => job.id === props.data.id);
      // uuidが存在する（新規データである）場合
      if (editData.uuid) {
        dispatch(createInventoryJob(editData));
        // uuidが存在しない（既存データである）場合
      } else {
        dispatch(updateInventoryJob(editData));
      }
    }
  };

  /**
   * Deleteボタンを押した時
   */
  const handleDeleteRow = (): void => {
    // console.log(props)
    if (isDeletable) {
      const editData = { ...props.data };
      dispatch(deleteInventoryJob(editData));
    }
  };

  return (
    <>
      <div id="editActions">
        <>
          <FontAwesomeIcon
            className="mr-3"
            icon={faEdit}
            size="lg"
            color={isEditable ? '#007bff' : '#ccc'}
            onClick={handleEditRow}
            style={isEditable ? { cursor: 'pointer' } : { cursor: 'default' }}
          />
          <FontAwesomeIcon icon={faMinusSquare} size="lg" color={isDeletable ? '#c4183c' : '#ccc'} onClick={handleDeleteRow} style={isDeletable ? { cursor: 'pointer' } : { cursor: 'default' }} />
        </>
      </div>
    </>
  );
};

export default ActionsInventoryJobRenderer;
